export const presaleAddress = "0x826BB51954b93f1972A3472aBf6DCd6672aDB462";
export const usdtAddress = "0xdac17f958d2ee523a2206206994597c13d831ec7";
